import React, { cloneElement } from 'react';
import { Section } from './ui/Section';
import { BookOpen, Calendar, PieChart, Coffee } from 'lucide-react';
export function IncludesSection() {
  return <Section background="white" data-id="element-111">
      <h2 className="text-3xl font-serif font-bold text-warm-dark mb-10 text-center" data-id="element-112">
        ¿Qué incluye el sistema?
      </h2>

      <div className="grid md:grid-cols-2 gap-8" data-id="element-113">
        <div className="space-y-6" data-id="element-114">
          <IncludeItem icon={<BookOpen data-id="element-116" />} title="El Plan Completo 3 Anclas" desc="La guía paso a paso para implementar el sistema sin dudas." data-id="element-115" />
          <IncludeItem icon={<PieChart data-id="element-118" />} title="Plantillas Visuales" desc="Aprende a armar tu plato sin báscula ni apps." data-id="element-117" />
          <IncludeItem icon={<Coffee data-id="element-120" />} title="Snacks de Rescate" desc="Opciones estratégicas para cuando el hambre ataca." data-id="element-119" />
        </div>
        <div className="space-y-6" data-id="element-121">
          <IncludeItem icon={<Calendar data-id="element-123" />} title="Calendario 14 Días" desc="Menú base de rotación para que no tengas que pensar." data-id="element-122" />
          <IncludeItem icon={<PieChart data-id="element-125" />} title="Método '2 Decisiones'" desc="Cómo comer fuera en restaurantes sin decir 'ya valió'." data-id="element-124" />
          <IncludeItem icon={<BookOpen data-id="element-127" />} title="Tracker Imprimible" desc="Mide tus antojos, energía y sueño para ver tu progreso." data-id="element-126" />
        </div>
      </div>
    </Section>;
}
function IncludeItem({
  icon,
  title,
  desc
}: {
  icon: React.ReactNode;
  title: string;
  desc: string;
}) {
  return <div className="flex items-start p-4 border border-cream-dark rounded-xl hover:bg-cream transition-colors" data-id="element-128">
      <div className="bg-peach/30 p-3 rounded-lg mr-4 text-terracotta" data-id="element-129">
        {cloneElement(icon as React.ReactElement, {
        size: 24
      })}
      </div>
      <div data-id="element-130">
        <h3 className="font-bold text-warm-dark text-lg" data-id="element-131">{title}</h3>
        <p className="text-warm-gray text-sm" data-id="element-132">{desc}</p>
      </div>
    </div>;
}